





























































































































































































































































































































































































































































import {Component, Vue} from 'vue-property-decorator';

@Component
export default class ServiceAgreeFooterModal extends Vue {
  isVisible: boolean = true;

  onServiceAgreeYn(serviceAgreeYn: boolean) {
    this.isVisible = false;
    this.$emit('onServiceAgreeYn', serviceAgreeYn);
    this.$emit('input', null);
  }

  onClose() {
    this.isVisible = false;
    this.$emit('input', null);
  }
}
